"use client";
import { DrawerBackdrop } from "./DrawerBackdrop.js";
import { DrawerBody } from "./DrawerBody.js";
import { DrawerClose } from "./DrawerClose.js";
import { DrawerDescription } from "./DrawerDescription.js";
import { DrawerHandle } from "./DrawerHandle.js";
import { DrawerPopup } from "./DrawerPopup.js";
import { DrawerPortal } from "./DrawerPortal.js";
import { DrawerRoot } from "./DrawerRoot.js";
import { DrawerTitle } from "./DrawerTitle.js";
import { DrawerTrigger } from "./DrawerTrigger.js";
import { DrawerViewport } from "./DrawerViewport.js";
const Drawer = {
    Root: DrawerRoot,
    Trigger: DrawerTrigger,
    Portal: DrawerPortal,
    Backdrop: DrawerBackdrop,
    Viewport: DrawerViewport,
    Popup: DrawerPopup,
    Body: DrawerBody,
    Handle: DrawerHandle,
    Title: DrawerTitle,
    Description: DrawerDescription,
    Close: DrawerClose
};
export { Drawer };
